import {
    FETCH_ACTIVITY_WEATHER,
    FETCH_ACTIVITY_WEATHER_SUCCESS,
    FETCH_ACTIVITY_WEATHER_FAIL,
    RESET_ACTIVITY_WEATHER
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    weather: []
};

const fetchActivityWeatherSuccess = (state, action) => {
    return {
        ...state,
        ...action.weather
    };
};

const fetchActivityWeatherFail = (state, action) => {
    return {
        ...state,
        ...action
    };
};

const resetWeather = (state) => {
    return {
        ...INITIAL_STATE
    };
};

const handlers = {
    [FETCH_ACTIVITY_WEATHER_SUCCESS]: fetchActivityWeatherSuccess,
    [FETCH_ACTIVITY_WEATHER_FAIL]: fetchActivityWeatherFail,
    [RESET_ACTIVITY_WEATHER]: resetWeather
};

export default function weather(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchActivityWeather(activityId) {
    return {
        type: FETCH_ACTIVITY_WEATHER,
        activityId: activityId
    };
}

export function resetActivityWeather() {
    return {
        type: RESET_ACTIVITY_WEATHER
    };
}

// Getters
export const getActivityWeather = (state) => {
    return state.weatherStationDTO;
};
